import { useQuery } from 'react-query';
import { WorkOrderChartFilter } from './WorkOrdersChart.types';
import WorkOrdersChartServices from './WorkOrdersChart.services';
import notificationError from '@/utils/functions/notificationError';

export function useWorkOrderChartIndicators(params?: WorkOrderChartFilter) {
  return useQuery(
    ['workOrder/chart/indicators', { ...params }],
    () => WorkOrdersChartServices.indicators(params),
    {
      enabled: !!params,
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useWorkOrderChartPeriodIndicators(
  params?: WorkOrderChartFilter,
) {
  return useQuery(
    ['workOrder/chart/period-indicators', { ...params }],
    () => WorkOrdersChartServices.periodIndicators(params),
    {
      enabled: !!params,
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useWorkOrderChartQuantity(params?: WorkOrderChartFilter) {
  return useQuery(
    ['workOrder/chart/quantity', { ...params }],
    () => WorkOrdersChartServices.quantity(params),
    {
      enabled: !!params,
      onError(err) {
        notificationError(err);
      },
    },
  );
}
